module.exports = __webpack_public_path__ + "img/free-ticket.fa3ddb48.svg";